// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contBI{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    /* background-color: red; */
}
.framebox{
    border-radius: var(--border-radios-small);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--border-table-color);
width: 90%;
/* height: 90%; */
aspect-ratio: 16/9;
}
`, "",{"version":3,"sources":["webpack://./src/components/reportes-components/styles/BI.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;AACA;IACI,yCAAyC;IACzC,0CAA0C;EAC5C,2CAA2C;AAC7C,UAAU;AACV,iBAAiB;AACjB,kBAAkB;AAClB","sourcesContent":[".contBI{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n    /* background-color: red; */\r\n}\r\n.framebox{\r\n    border-radius: var(--border-radios-small);\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n  border: 1px solid var(--border-table-color);\r\nwidth: 90%;\r\n/* height: 90%; */\r\naspect-ratio: 16/9;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
